import React from "react";
import { Badge } from "Components/Base/DataDisplay/Badge";

const FilterHitCount = ({ hitCount, languageContext }) => {
  return (
    <Badge badgeContent={hitCount ?? 0} color="primary" showZero>
      <strong>{languageContext("hits")}:</strong>
    </Badge>
  );
};

export default FilterHitCount;
